import InspectionLocationContainer from "./InspectionLocation.container";

export default InspectionLocationContainer;
